/** @file agentPrompt: the text the Agent screen copies for the human to paste to their agent. */
import type { EditorState } from '../state/editorTypes';

/** The slice of state the prompt names. */
export type PromptInput = Pick<EditorState, 'puppet' | 'selection' | 'playhead'> & { url: string };

/** Puppet id and name, its project id, revision, server, selected nodes, clip and frame, then an empty task line. */
export function agentPrompt({ puppet, selection, playhead, url }: PromptInput): string {
  const nodes = selection.nodes.length === 0 ? '(none)' : selection.nodes.join(', ');
  const clip = playhead.clip === null ? '(no clip)' : `${playhead.clip}, frame ${String(playhead.frame)}`;
  const id = puppet.id ?? '(none)';
  const name = puppet.doc === null ? '' : ` ("${puppet.doc.name}")`;
  return [
    `Pose3D puppet ${id}${name} in project ${puppet.projectId ?? '(unknown)'}, at revision ${String(puppet.revision)}.`,
    `Server: ${url}`,
    `Selected nodes: ${nodes}`,
    `Clip: ${clip}`,
    `Use the Pose3D MCP puppet tools with { puppet: "${id}" }; re-read it first (the human may have edited since).`,
    'Task: ',
  ].join('\n');
}
